import { fetch } from '@okapi/fetch';
import { parseRawBundleConfig } from '@okapi/store-config';
import { isBrowser } from '@okapi/dom-utils';
/**
 * Запрашивает конфиг микрофронта
 * @param sdServer адрес SD сервера
 * @param microfront названия микрофронта
 */
export const fetchMicrofrontBundle = async (sdServer, microfront) => {
    var _a;
    if (isBrowser() && ((_a = window.microfronts) === null || _a === void 0 ? void 0 : _a[microfront])) {
        return window.microfronts[microfront];
    }
    const configUrl = `${sdServer}/okapi/${microfront}/config`.replace('//okapi', '/okapi');
    const response = await fetch(configUrl, {
        method: 'POST',
        body: '[]',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    const parsedJson = await response.json();
    const bundle = parseRawBundleConfig(parsedJson);
    if (isBrowser()) {
        if (!window.microfronts) {
            window.microfronts = {};
        }
        window.microfronts[microfront] = bundle;
    }
    return bundle;
};
